import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_DROPDOWN_MENU_ITEMS_LIST } from "../../../actions/types";
import { CoreService, TransactionsService, MaterialReceivingService, PurchaseOrdersService } from "../../../services";
import { Backdrop, Box, Button, Card, CardContent, CardHeader, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, LinearProgress, MenuItem, OutlinedInput, Paper, TextField, Typography } from '@material-ui/core';
import { SuccessDialog } from '../../../components/shared';
import Alert from '@material-ui/lab/Alert';
import { DataGrid, GridOverlay } from '@material-ui/data-grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import * as yup from 'yup';
import { Formik, Form, useFormik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { red } from '@material-ui/core/colors';
import { Calendar, HelpCircleOutline, TextBoxSearchOutline } from "mdi-material-ui";
import allowAction from '../../../helpers/allowAction';
import * as _ from 'lodash';


const validationSchema = yup.object({
    operationTeam: yup.string().required("Operation Team is required"),
    vehicleType: yup.string().required("Vehicule Type is required"),
    factoryName: yup.string().required("Factory Name is required"),
    materialName: yup.string().required("Material Name is required"),
    materialNo: yup.string().required("Material No is required"),
    poNo: yup.string().required("Purchase Order is required"),
    poItemNo: yup.string().required("Purchase Order Item is required"),
    plantTo: yup.string().required("Plant is required"),
    slocTo: yup.string().required("Storage Location is required"),
    vendorName: yup.string().required("Vendor is required"),
    vendorDoNo: yup.string().required("Do / Invoice is required"),
    //truckNo: yup.string().required("Weight Out is requiered"),
    truckNo: yup.string().when('vehicleType', {
        is: 'Truck',
        then: yup.string().required('Truck No is required'),
        otherwise: yup.string().required('Vessel is required'),
    }),
    tankTo: yup.string().when('vehicleType', {
        is: 'Truck',
        then: yup.string().required('Tank is required')
    }),
    unit: yup.string().required("Unit is requiered"),
    vendorDoWeight: yup.number().typeError('Weight In must be numeric').required("Do Weight is required"),
    netWeight: yup.number().typeError('Net Weight Out must be numeric').required("Net Weight is required"),
    weightOut: yup.number().when('vehicleType', {
        is: 'Truck',
        then: yup.number().typeError('Weight Out must be numeric').required("Weight Out must be numeric")
    }),
    weightIn: yup.number().when('vehicleType', {
        is: 'Truck',
        then: yup.number().typeError('Weight In must be numeric').required("Weight In must be numeric")
    }),
});
function LoadingTableOverlay() {
    return (
        <GridOverlay>
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
                <LinearProgress />
            </div>
        </GridOverlay>
    );
}

export default function MaterialReceivingEdit(props) {
    const { transactionData, open, onClose, handleSearchSubmit, handleAddNewReload, transactions, setTransactions, setFilteredTransactions } = props;
    const dropdownItemsStore = useSelector((state) => state.dropdownMenuItems);
    const classes = useStyles();
    const dispatch = useDispatch();
    const dateNow = new Date();

    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoadingCoTicketId, setIsLoadingCoTicketId] = useState(false);

    const [autocompleteData, setAutocompleteData] = useState({ plantTo: { text: "", value: "" }, slocTo: { text: "", value: "" }, operationTeam: { text: "", value: "" }, vehicleType: { text: "", value: "" }, tankTo: { text: "", value: "" }, unit: { text: "", value: "" }, coTicketId: { text: "", value: "" } })
    const [dropdownStorageLocation, setDropdownStorageLocation] = useState([{ text: "Select a Plant first", value: "" }]);
    const [dropdownStatus, setDropdownStatus] = useState([{ text: "Entry", value: "10" }, { text: "Cancel", value: "90" }]);

    const [formData, setFormData] = useState(transactionData);
    const [openCoTicketId, setOpenCoTicketId] = React.useState(false);
    const [coTicketId, setCoTicketId] = React.useState({ text: "", value: "" });
    const [coTicketIdOptions, setCoTicketIdOptions] = React.useState([{ text: "", value: "" }]);
    //const [dropdownItemsCoTicket, setDropdownItemsCoTicket] = React.useState([]);

    // Dialog
    const [openPurchaseOrderDialog, setOpenPurchaseOrderDialog] = useState(false);
    const [poItems, setPoItems] = useState({});
    const [serverSideError, setServerSideError] = useState({ coTicketId: { hasError: false, error: "" } });
    const [successDialog, setSuccessDialog] = useState({ isOpen: false, title: '', subTitle: '' })

    //Buttons
    const [saveButton, setSaveButton] = useState({ disabled: false, loading: false });
    const [reSubmitButton, setReSubmitButton] = useState({ disabled: false, loading: false });

    // Formik do not handle null value
    for (var key in formData) {
        if (formData.hasOwnProperty(key)) {
            if (formData[key] === null) {
                formData[key] = ""
            }
        }
    }
    const formik = useFormik({
        initialValues: formData,
        validationSchema: validationSchema,
        onSubmit: values => {
            //setSaveButton({ disabled: true, loading: true })
            // Some field on the Oracle database don't allow empty string (createDate, weightIn, etc...)
            for (var key in values) {
                if (values.hasOwnProperty(key)) {
                    if (values[key] === "") {
                        values[key] = null;
                    }
                }
            }
            TransactionsService.editTransaction(values).then(
                (response) => {
                    const data = response.data;
                    if (data && data.errors) {
                        setServerSideError(data.errors)
                    }
                    else {
                        setServerSideError({ coTicketId: { hasError: false, error: "" } })
                        if (transactions) {
                            let ticketsIds = transactions.map(function (item) {
                                return item['ticketId'];
                            });
                            ticketsIds.push(response.data.data.ticketId);
                            TransactionsService.getTransactionsByTicketsIds(ticketsIds).then(
                                (response) => {
                                    setTransactions(response.data);
                                    setFilteredTransactions(response.data);
                                });
                        }
                        else {
                            handleSearchSubmit();
                        }
                        onClose();
                    }
                    setSaveButton({ disabled: false, loading: false })
                    setReSubmitButton({ disabled: false, loading: false })
                });
        },
    });
    function getAutocompleteTextAndValue(field, value) {
        var selection = dropdownItemsStore[field].filter(function (option) {
            return option.value === value;
        });
        if (selection.length === 0) {
            selection = [{ text: '', value: '' }];
        }
        return selection;
    }
    useEffect(() => {
        formik.setFieldValue('transactionType', 'GR');
        /* Retreive dropdown if they are not already in the Redux store*/
        let dropdownToGet = ['sapPlant', 'operationTeam', 'status', 'vehicleType', 'sapStorageLocation', 'sapMaterial', 'tank', 'unit']
        let dropdownNotInTheStore = [];
        for (var key in dropdownItemsStore) {
            if (dropdownItemsStore[key].length === 0 && dropdownToGet.includes(key)) {
                dropdownNotInTheStore.push(key);
            }
        }
        if (dropdownNotInTheStore.length !== 0) {
            setIsLoading(true);
            CoreService.dropdownItems(dropdownNotInTheStore).then(
                (response) => {
                    const data = response.data;
                    dispatch({
                        type: SET_DROPDOWN_MENU_ITEMS_LIST,
                        payload: data,
                    });
                    setIsLoading(false);
                })
        }
        if (formData && formData.ticketId !== "") {
            setAutocompleteData({
                tankTo: getAutocompleteTextAndValue('tank', formData.tankTo)[0],
                plantTo: getAutocompleteTextAndValue('sapPlant', formData.plantTo)[0],
                slocTo: getAutocompleteTextAndValue('sapStorageLocation', formData.slocTo)[0],
                operationTeam: getAutocompleteTextAndValue('operationTeam', formData.operationTeam)[0],
                vehicleType: getAutocompleteTextAndValue('vehicleType', formData.vehicleType)[0],
                status: getAutocompleteTextAndValue('status', formData.status)[0],
                unit: getAutocompleteTextAndValue('unit', formData.unit)[0],
                coTicketId: { value: formData.coTicketId, text: formData.coTicketId }
            });
            MaterialReceivingService.autocompleteCoTicketByTicket({ poNo: formik.values.poNo, poItemNo: formik.values.poItemNo, truckNo: formik.values.truckNo }).then(
                (response) => {
                    const data = response.data.data;
                    setCoTicketIdOptions(data);
                    //setIsLoadingCoTicketId(false)
                });
            //setCoTicketIdOptions()
        }
        /*else {
            setAutocompleteData({
                plantTo: getAutocompleteTextAndValue('sapPlant', formData.plantTo)[0],
                vehicleType: getAutocompleteTextAndValue('vehicleType', formData.vehicleType)[0],
            });
        }*/
        var newStorageLocationList = dropdownItemsStore.sapStorageLocation.filter(function (location) {
            return location.plant === formData.plantTo;
        });
        setDropdownStorageLocation(newStorageLocationList);
        setIsLoaded(true);
    }, [formData, dispatch]);

    const handleAutoCompleteChange = (target, fieldName) => {
        var value = target !== null ? target.value : ''
        var text = target !== null ? target.text : ''
        formik.setFieldValue([fieldName], value);
        if (fieldName === 'plantTo') {
            var newStorageLocationList = dropdownItemsStore["sapStorageLocation"].filter(function (location) {
                return location.plant === value;
            });
            setDropdownStorageLocation(newStorageLocationList);
            setAutocompleteData({ ...autocompleteData, plantTo: { text, value }, slocTo: { text: '', value: '' } });
        }
        /*else if (fieldName === 'coTicketId'){
            MaterialReceivingService.autocompleteCoTicketByTicket({ poNo: formik.values.poNo, poItemNo: formik.values.poItemNo, truckNo: formik.values.truckNo }).then(
                (response) => {
                    setCoTicketIdOptions(response.data.data);
                });
        }*/
        else {
            setAutocompleteData({ ...autocompleteData, [fieldName]: { text: text, value: value } })
        }
    };
    /*const handleAutoCompleteCoTicketChange = (target, fieldName) => {

    }*/
    const handleDateChange = (date) => {
        formik.setFieldValue('loadingDate', date);
        setFormData({ ...formData, loadingDate: date });
    };
    const handlePurchaseOrdersDialogOpen = () => {
        setOpenPurchaseOrderDialog(true);
    };
    const handlePurchaseOrdersDialogClose = () => {
        setOpenPurchaseOrderDialog(false);
    };
    const handleEditDialogClose = () => {
        onClose();
    };
    const handleEditDialogSubmit = () => {
        setSaveButton({ disabled: true, loading: true })
        formik.handleSubmit();
        if (Object.keys(formik.errors).length !== 0) {
            setSaveButton({ disabled: false, loading: false })
        }
        else {
            handleSearchSubmit();
        }
    };
    const handleEditDialogReSubmit = () => {

        setReSubmitButton({ disabled: true, loading: true })
        formik.setFieldValue('status', "30");
        formik.handleSubmit();
        if (Object.keys(formik.errors).length !== 0) {
            setReSubmitButton({ disabled: false, loading: false })
        }
        else {
            //handleSearchSubmit();
        }
    }
    const handleSetPoItems = () => {
        if (poItems) {
            const po = poItems[0];
            formik.setFieldValue('poNo', po.poNo);
            formik.setFieldValue('poItemNo', po.poItemNo);
            formik.setFieldValue('poNo', po.poNo);
            formik.setFieldValue('materialNo', po.materialNo);
            formik.setFieldValue('materialName', po.materialShort);
            formik.setFieldValue('vendorName', po.customerName);
        }
    };

    const handleCoTicketChange = async value => {
        setServerSideError({ coTicketId: { hasError: false, error: "" } })
        if (value && value.length > 0) {
            formik.setFieldValue('coTicketId', value);
            MaterialReceivingService.autocompleteCoTicketByTicket({ poNo: formik.values.poNo, poItem: formik.values.poItem, truckNo: formik.values.truckNo }).then(
                (response) => {
                    const data = response.data.data;
                    setCoTicketIdOptions(data);
                });

        }
        else {
            formik.setFieldValue('coTicketId', '')
        }
    };

    const handleCoTicketRemove = () => {
        formik.setFieldValue('netWeight', formData.weightIn - formData.weightOut)
        setSuccessDialog({ isOpen: true, title: 'Co-Ticket Deleted', subTitle: 'The co-ticket has been deleted successfully and the Net Weight recalculated. You need to manually recalculate the Net Weight for the other ticket(s)' })
    };
    return (
        <>
            <Dialog scroll="paper" fullWidth={true} maxWidth={'lg'} open={open} onClose={handleEditDialogClose}>
                <DialogTitle
                    id="form-dialog-title">
                    <Grid container>
                        <Grid item xs={6}>
                            {formData?.ticketId ? <>Ticket ID: {formData?.ticketId}</> : <>Create a new ticket</>}
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Formik>
                        <Form onSubmit={formik.handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Card className={classes.card}>
                                        <CardHeader
                                            className={classes.cardHeader}
                                            action={
                                                <IconButton aria-label="settings">
                                                    <HelpCircleOutline />
                                                </IconButton>
                                            }
                                            title="GENERAL DATA"
                                        />
                                        <CardContent>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Status</Grid>
                                                        <Grid item xs={7}>
                                                            <Autocomplete
                                                                id="statusAutocomplete"
                                                                name="statusAutocomplete"
                                                                closeIcon=""
                                                                disabled={formik.values.status === "50" ? true : false}
                                                                options={dropdownStatus}
                                                                value={autocompleteData.status ? { text: autocompleteData.status.text, value: autocompleteData.status.value } : ""}
                                                                getOptionLabel={(option) => option.text}
                                                                renderOption={option => <>{option.text}</>}
                                                                onChange={(event, newValue) => {
                                                                    handleAutoCompleteChange(newValue, 'status');
                                                                }}
                                                                renderInput={(params) => <TextField {...params}
                                                                    id="statusAutocomplete"
                                                                    name="statusAutocomplete"
                                                                    size="small"
                                                                    variant="outlined"
                                                                //error={formik.touched.operationTeam && Boolean(formik.errors.operationTeam)}
                                                                //helperText={formik.touched.operationTeam && formik.errors.operationTeam}
                                                                />}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Loading Date <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                <Grid container justify="space-around">
                                                                    <KeyboardDatePicker
                                                                        disableToolbar
                                                                        autoOk={true}
                                                                        size="small"
                                                                        fullWidth
                                                                        inputVariant="outlined"
                                                                        format="dd/MM/yyyy"
                                                                        id="loadingDate"
                                                                        name="loadingDate"
                                                                        //minDate={new Date(dateNow.getFullYear(), dateNow.getMonth() - 1, dateNow.getDate())}
                                                                        //maxDate={new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate())}
                                                                        minDate={formik.values.loadingDate !== null ? new Date("1900-01-01") : new Date(dateNow.getFullYear(), dateNow.getMonth() - 1, dateNow.getDate())}
                                                                        maxDate={formik.values.loadingDate !== null ? new Date("2100-01-01") : new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate())}
                                                                        onChange={handleDateChange}
                                                                        value={formik.values.loadingDate}
                                                                        keyboardIcon={<Calendar style={{ marginRight: -15 }} />}
                                                                        KeyboardButtonProps={{
                                                                            'aria-label': 'change date',
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </MuiPickersUtilsProvider>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Batch</Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                value={formik.values.batchNoTo}
                                                                onChange={formik.handleChange}
                                                                id="batchNoTo"
                                                                name="batchNoTo"
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Po No <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined">
                                                                <OutlinedInput
                                                                    disabled
                                                                    id="poNo"
                                                                    name="poNo"
                                                                    size="small"
                                                                    variant="outlined"
                                                                    className={classes.textfield}
                                                                    value={formik.values.poNo}
                                                                    onChange={formik.handleChange}
                                                                    //error={formik.touched.poNo && Boolean(formik.errors.poNo)}
                                                                    //helperText={formik.touched.poNo && formik.errors.poNo}
                                                                    margin="dense"
                                                                    endAdornment={
                                                                        <InputAdornment position="end">
                                                                            <IconButton
                                                                                aria-label="purchase orders"
                                                                                onClick={handlePurchaseOrdersDialogOpen}
                                                                                edge="end"
                                                                            >
                                                                                <TextBoxSearchOutline />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    }
                                                                />
                                                                <FormHelperText error={formik.touched.poNo && Boolean(formik.errors.poNo)} id="accountId-error">
                                                                    {formik.touched.poNo && formik.errors.poNo}
                                                                </FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Po Item <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="poItemNo"
                                                                name="poItemNo"
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                className={classes.textfield}
                                                                value={formik.values.poItemNo}
                                                                onChange={formik.handleChange}
                                                                error={formik.touched.poItemNo && Boolean(formik.errors.poItemNo)}
                                                                helperText={formik.touched.poItemNo && formik.errors.poItemNo}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Do / Invoice <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="vendorDoNo"
                                                                name="vendorDoNo"
                                                                size="small"
                                                                variant="outlined"
                                                                className={classes.textfield}
                                                                value={formik.values.vendorDoNo}
                                                                onChange={formik.handleChange}
                                                                error={formik.touched.vendorDoNo && Boolean(formik.errors.vendorDoNo)}
                                                                helperText={formik.touched.vendorDoNo && formik.errors.vendorDoNo}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Operation Team <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <Autocomplete
                                                                id="operationTeamAutocomplete"
                                                                name="operationTeamAutocomplete"
                                                                closeIcon=""
                                                                options={dropdownItemsStore["operationTeam"]}
                                                                value={autocompleteData.operationTeam ? { text: autocompleteData.operationTeam.text, value: autocompleteData.operationTeam.value } : ""}
                                                                getOptionLabel={(option) => option.text}
                                                                renderOption={option => <>{option.text}</>}
                                                                onChange={(event, newValue) => {
                                                                    handleAutoCompleteChange(newValue, 'operationTeam');
                                                                }}
                                                                renderInput={(params) => <TextField {...params}
                                                                    id="operationTeamAutocomplete"
                                                                    name="operationTeamAutocomplete"
                                                                    size="small"
                                                                    variant="outlined"
                                                                    error={formik.touched.operationTeam && Boolean(formik.errors.operationTeam)}
                                                                    helperText={formik.touched.operationTeam && formik.errors.operationTeam}
                                                                />}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Vendor <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                disabled
                                                                value={formik.values.vendorName}
                                                                id="vendorName"
                                                                name="vendorName"
                                                                size="small"
                                                                variant="outlined"
                                                                error={formik.touched.vendorName && Boolean(formik.errors.vendorName)}
                                                                helperText={formik.touched.vendorName && formik.errors.vendorName}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Factory <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="factoryName"
                                                                name="factoryName"
                                                                size="small"
                                                                variant="outlined"
                                                                value={formik.values.factoryName}
                                                                onChange={formik.handleChange}
                                                                error={formik.touched.factoryName && Boolean(formik.errors.factoryName)}
                                                                helperText={formik.touched.factoryName && formik.errors.factoryName}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Plant <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <Autocomplete
                                                                id="plantToAutocomplete"
                                                                name="plantToAutocomplete"
                                                                closeIcon=""
                                                                options={dropdownItemsStore["sapPlant"]}
                                                                value={autocompleteData.plantTo ? { text: autocompleteData.plantTo.text, value: autocompleteData.plantTo.value } : ""}
                                                                getOptionLabel={(option) => option.text}
                                                                renderOption={option => <>{option.text}</>}
                                                                onChange={(event, newValue) => {
                                                                    handleAutoCompleteChange(newValue, 'plantTo');
                                                                }}
                                                                renderInput={(params) => <TextField {...params}
                                                                    id="plantToAutocomplete"
                                                                    name="plantToAutocomplete"
                                                                    size="small"
                                                                    variant="outlined"
                                                                    error={formik.touched.plantTo && Boolean(formik.errors.plantTo)}
                                                                    helperText={formik.touched.plantTo && formik.errors.plantTo}
                                                                />}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Storage <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <Autocomplete
                                                                id="storageToAutocomplete"
                                                                name="storageToAutocomplete"
                                                                closeIcon=""
                                                                options={dropdownStorageLocation}
                                                                value={autocompleteData.slocTo ? { text: autocompleteData.slocTo.text, value: autocompleteData.slocTo.value } : ""}
                                                                getOptionLabel={(option) => option.text}
                                                                renderOption={option => <>{option.text}</>}
                                                                onChange={(event, newValue) => {
                                                                    handleAutoCompleteChange(newValue, 'slocTo');
                                                                }}
                                                                renderInput={(params) => <TextField {...params}
                                                                    id="storageToAutocomplete"
                                                                    name="storageToAutocomplete"
                                                                    size="small"
                                                                    variant="outlined"
                                                                    error={formik.touched.slocTo && Boolean(formik.errors.slocTo)}
                                                                    helperText={formik.touched.slocTo && formik.errors.slocTo}
                                                                />}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Material No <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="materialNo"
                                                                name="materialNo"
                                                                size="small"
                                                                variant="outlined"
                                                                className={classes.textfield}
                                                                value={formik.values.materialNo}
                                                                onChange={formik.materialNo}
                                                                disabled
                                                                error={formik.touched.materialNo && Boolean(formik.errors.materialNo)}
                                                                helperText={formik.touched.materialNo && formik.errors.materialNo}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Material<Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="materialName"
                                                                name="materialName"
                                                                size="small"
                                                                variant="outlined"
                                                                value={formik.values.materialName}
                                                                onChange={formik.materialName}
                                                                disabled
                                                                error={formik.touched.materialName && Boolean(formik.errors.materialName)}
                                                                helperText={formik.touched.materialName && formik.errors.materialName}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Vehicle Type <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <Autocomplete
                                                                id="vehicleTypeAutocomplete"
                                                                name="vehicleTypeAutocomplete"
                                                                closeIcon=""
                                                                options={dropdownItemsStore["vehicleType"]}
                                                                value={autocompleteData.vehicleType ? { text: autocompleteData.vehicleType.text, value: autocompleteData.vehicleType.value } : ""}
                                                                getOptionLabel={(option) => option.text}
                                                                renderOption={option => <>{option.text}</>}
                                                                onChange={(event, newValue) => {
                                                                    handleAutoCompleteChange(newValue, 'vehicleType');
                                                                }}
                                                                renderInput={(params) => <TextField {...params}
                                                                    id="vehicleTypeAutocomplete"
                                                                    name="vehicleTypeAutocomplete"
                                                                    size="small"
                                                                    variant="outlined"
                                                                    error={formik.touched.vehicleType && Boolean(formik.errors.vehicleType)}
                                                                    helperText={formik.touched.vehicleType && formik.errors.vehicleType}
                                                                />}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>{formik.values.vehicleType === "Truck" ? <>Truck Company</> : <>Vessel Company</>}</Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="transportCom"
                                                                name="transportCom"
                                                                size="small"
                                                                variant="outlined"
                                                                value={formik.values.transportCom}
                                                                onChange={formik.handleChange}
                                                            //error={formik.touched.transportCom && Boolean(formik.errors.transportCom)}
                                                            //helperText={formik.touched.transportCom && formik.errors.transportCom}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>{formik.values.vehicleType === "Truck" ? <>Truck No / Name </> : <>Vessel Name </>}<Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="truckNo"
                                                                name="truckNo"
                                                                size="small"
                                                                variant="outlined"
                                                                className={classes.textfield}
                                                                value={formik.values.truckNo}
                                                                onChange={formik.handleChange}
                                                                error={formik.touched.poNo && Boolean(formik.errors.truckNo)}
                                                                helperText={formik.touched.poNo && formik.errors.truckNo}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}></Grid>
                                                        <Grid item xs={7}>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Co-Ticket</Grid>
                                                        <Grid item xs={7}>
                                                            <Autocomplete
                                                                id="coTicketIdToAutocomplete"
                                                                name="coTicketIdToAutocomplete"
                                                                //closeIcon=""
                                                                options={coTicketIdOptions}
                                                                //value={coTicketIdOptions ? { text: coTicketIdOptions.text, value: coTicketIdOptions.value } : ""}
                                                                value={autocompleteData.coTicketId ? { text: autocompleteData.coTicketId.text, value: autocompleteData.coTicketId.value } : ""}
                                                                //value={formik.values.coTicketId ? { text: formik.values.coTicketId, value: formik.values.coTicketId } : ""}
                                                                getOptionLabel={(option) => option.text}
                                                                renderOption={option => <>{option.text}</>}
                                                                /*onChange={(event, newValue) => {
                                                                    handleAutoCompleteChange(newValue, 'coTicketId');
                                                                }}*/
                                                                onChange={(event, newValue) => {
                                                                    handleAutoCompleteChange(newValue, 'coTicketId');
                                                                    formik.setFieldValue('coTicketId', newValue === null ? '' : newValue.value);
                                                                    if (newValue === null) {
                                                                        handleCoTicketRemove();
                                                                    }
                                                                }}
                                                                renderInput={(params) => <TextField {...params}
                                                                    id="coTicketIdToAutocomplete"
                                                                    name="coTicketIdToAutocomplete"
                                                                    size="small"
                                                                    variant="outlined"
                                                                //error={formik.touched.coTicketId && Boolean(formik.errors.coTicketId)}
                                                                //helperText={formik.touched.coTicketId && formik.errors.coTicketId}
                                                                />}
                                                            />
                                                            {/*<Autocomplete
                                                                id="coTicketIdToAutocomplete"
                                                                name="coTicketIdToAutocomplete"
                                                                options={coTicketIdOptions}
                                                                value={formik.values.coTicketId ? { text: formik.values.coTicketId, value: formik.values.coTicketId } : ""}
                                                                open={openCoTicketId}
                                                                onOpen={() => {
                                                                    setOpenCoTicketId(true);
                                                                }}
                                                                onClose={() => {
                                                                    setOpenCoTicketId(false);
                                                                }}
                                                                getOptionSelected={(option, value) => option.text === value.text}
                                                                getOptionLabel={(option) => option.text}
                                                                onChange={(event, newInputValue) => {
                                                                    formik.setFieldValue('coTicketId', newInputValue === null ? '' : newInputValue.value);
                                                                    if (newInputValue === null) {
                                                                        handleCoTicketRemove();
                                                                    }
                                                                }}
                                                                loading={isLoadingCoTicketId}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        id="coTicketIdToAutocomplete"
                                                                        name="coTicketIdToAutocomplete"
                                                                        size="small"
                                                                        variant="outlined"
                                                                        onChange={ev => {
                                                                            if (ev.target.value !== "" || ev.target.value !== null) {
                                                                                handleCoTicketChange(ev.target.value);
                                                                            }
                                                                        }}
                                                                        error={serverSideError.coTicketId.hasError}
                                                                        helperText={serverSideError.coTicketId.error}
                                                                        InputProps={{
                                                                            ...params.InputProps,
                                                                            endAdornment: (
                                                                                <React.Fragment>
                                                                                    {isLoadingCoTicketId ? <CircularProgress color="inherit" size={20} /> : null}
                                                                                    {params.InputProps.endAdornment}
                                                                                </React.Fragment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                )}
                                                            />*/}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container className={classes.gridContainer}>
                                                        <Grid item xs={5} className={classes.label}>Unit <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <Autocomplete
                                                                id="unitAutocomplete"
                                                                name="unitAutocomplete"
                                                                closeIcon=""
                                                                options={dropdownItemsStore["unit"]}
                                                                value={autocompleteData.unit ? { text: autocompleteData.unit.text, value: autocompleteData.unit.value } : ""}
                                                                getOptionLabel={(option) => option.text}
                                                                renderOption={option => <>{option.text}</>}
                                                                onChange={(event, newValue) => {
                                                                    handleAutoCompleteChange(newValue, 'unit');
                                                                }}
                                                                renderInput={(params) => <TextField {...params}
                                                                    id="unitAutocomplete"
                                                                    name="unitAutocomplete"
                                                                    size="small"
                                                                    variant="outlined"
                                                                    error={formik.touched.unit && Boolean(formik.errors.unit)}
                                                                    helperText={formik.touched.unit && formik.errors.unit}
                                                                />}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <Grid container spacing={1} style={{ textAlign: "center" }}>
                                                {formik.values.vehicleType === "Truck" ?
                                                    <>
                                                        <Grid item xs={2}></Grid>
                                                        <Grid item xs={8}>
                                                            <Grid container
                                                                direction="row"
                                                                justify="center"
                                                                alignItems="center"
                                                                spacing={0}
                                                            >
                                                                <Grid item xs={6} className={classes.label}>Tank <Typography component="span" color="error">*</Typography></Grid>
                                                                <Grid item xs={6}>
                                                                    <Autocomplete
                                                                        id="tankToAutocomplete"
                                                                        name="tankToAutocomplete"
                                                                        closeIcon=""
                                                                        options={dropdownItemsStore["tank"]}
                                                                        value={autocompleteData.tankTo ? { text: autocompleteData.tankTo.text, value: autocompleteData.tankTo.value } : ""}
                                                                        getOptionLabel={(option) => option.text}
                                                                        renderOption={option => <>{option.text}</>}
                                                                        onChange={(event, newValue) => {
                                                                            handleAutoCompleteChange(newValue, 'tankTo');
                                                                        }}
                                                                        renderInput={(params) => <TextField {...params}
                                                                            id="tankToAutocomplete"
                                                                            name="tankToAutocomplete"
                                                                            size="small"
                                                                            variant="outlined"
                                                                            error={formik.touched.tankTo && Boolean(formik.errors.tankTo)}
                                                                            helperText={formik.touched.tankTo && formik.errors.tankTo}
                                                                        />}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Divider />
                                                        </Grid>
                                                    </>
                                                    : <></>}
                                                {formik.values.vehicleType === "Truck" ?
                                                    <>
                                                        <Grid item xs={12} md={6}>
                                                            <Grid container spacing={0}>
                                                                <Grid item xs={5} className={classes.label}>Weight In <Typography component="span" color="error">*</Typography></Grid>
                                                                <Grid item xs={7}>
                                                                    <TextField
                                                                        id="weightIn"
                                                                        name="weightIn"
                                                                        size="small"
                                                                        variant="outlined"
                                                                        value={formik.values.weightIn}
                                                                        onChange={formik.handleChange}
                                                                        error={formik.touched.weightIn && Boolean(formik.errors.weightIn)}
                                                                        helperText={formik.touched.weightIn && formik.errors.weightIn}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Grid container spacing={0}>
                                                                <Grid item xs={5} className={classes.label}>Weight Out <Typography component="span" color="error">*</Typography></Grid>
                                                                <Grid item xs={7}>
                                                                    <TextField
                                                                        id="weightOut"
                                                                        name="weightOut"
                                                                        size="small"
                                                                        variant="outlined"
                                                                        className={classes.textfield}
                                                                        value={formik.values.weightOut}
                                                                        onChange={formik.handleChange}
                                                                        error={formik.touched.weightOut && Boolean(formik.errors.weightOut)}
                                                                        helperText={formik.touched.weightOut && formik.errors.weightOut}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                    : <></>
                                                }
                                                <Grid item xs={12}>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={5} className={classes.label}>Net Weight <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="netWeight"
                                                                name="netWeight"
                                                                size="small"
                                                                variant="outlined"
                                                                className={classes.textfield}
                                                                value={formik.values.netWeight}
                                                                onChange={formik.handleChange}
                                                                error={formik.touched.netWeight && Boolean(formik.errors.netWeight)}
                                                                helperText={formik.touched.netWeight && formik.errors.netWeight}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={5} className={classes.label}>Do Weight <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="vendorDoWeight"
                                                                name="vendorDoWeight"
                                                                size="small"
                                                                variant="outlined"
                                                                className={classes.textfield}
                                                                value={formik.values.vendorDoWeight}
                                                                onChange={formik.handleChange}
                                                                error={formik.touched.vendorDoWeight && Boolean(formik.errors.vendorDoWeight)}
                                                                helperText={formik.touched.vendorDoWeight && formik.errors.vendorDoWeight}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Divider />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={5} className={classes.label}>Diff <Typography component="span" color="error">*</Typography></Grid>
                                                        <Grid item xs={7}>
                                                            <TextField
                                                                id="diffWeight"
                                                                name="diffWeight"
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                className={classes.textfield}
                                                                value={formik.values.vendorDoWeight !== "" && formik.values.netWeight !== "" && !isNaN(formik.values.vendorDoWeight) && !isNaN(formik.values.netWeight) ? Number(formik.values.vendorDoWeight) - Number(formik.values.netWeight) : ""}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid justify="flex-end" container spacing={0}>
                                                        <Box style={{ textAlign: 'left' }}>
                                                            <Typography style={{ fontSize: 12 }} component="span" color="error">* Required fields</Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box height="100%"
                                    >
                                        <Box width="100%" height="90%" alignSelf="flex-start" justifyContent="center">
                                            {formData.comments ?
                                                <Alert severity="error">{formData.comments}</Alert> : <></>}
                                        </Box>
                                        <Box width="100%" height="10%" display="flex" justifyContent="center">
                                            <Box alignSelf="flex-end">
                                                {formData && formData.ticketId !== "" ?
                                                    <>
                                                        UPDATED BY: <Box mr={1} px={1} py={1} component="span">{formData.modBy === "" ? formData.createBy : formData.modBy}</Box>
                                                        UPDATE DATE: <Box px={1} py={1} component="span">{formData.modDate === "" ? new Date(formData.createDate).toLocaleDateString('en-GB') : new Date(formData.modDate).toLocaleDateString('en-GB')}</Box>
                                                    </>
                                                    : <></>}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    </Formik>
                    <PurchaseOrdersDialog handleSetPoItems={handleSetPoItems} setPoItems={setPoItems} open={openPurchaseOrderDialog} onClose={handlePurchaseOrdersDialogClose} />
                </DialogContent>
                <DialogActions>
                    {allowAction("101", "edit") ?
                        <Box component="span" className={classes.buttonWrapper}>
                            <Button disabled={saveButton.disabled || formData.status === '50'} onClick={handleEditDialogSubmit} variant="contained" color="default">Save</Button>
                            {saveButton.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </Box>
                        : null}
                    <Button onClick={handleEditDialogClose} variant="contained" color="default">Close</Button>
                    {(formData.status === "10" || formData.status === "20") && allowAction("101", "submit") ?
                        <Box component="span" className={classes.buttonWrapper}>
                            <Button disabled={reSubmitButton.disabled} onClick={handleEditDialogReSubmit} variant="contained" color="default">Submit</Button>
                            {reSubmitButton.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </Box> : <></>}
                </DialogActions>
                <Backdrop className={classes.backdrop} open={isLoaded}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Dialog>
            <SuccessDialog successDialog={successDialog}
                setSuccessDialog={setSuccessDialog}
            />
        </>
    );
}
const useStyles = makeStyles(theme => ({
    //#region Edit/Create Dialog
    label: {
        paddingTop: '10px',
        paddingLeft: '20px',
        textTransform: 'uppercase'
    },
    gridContainer: {
        paddingTop: '4px',
        paddingBottom: '4px',
    },
    card: {
        backgroundColor: theme.palette.type === 'light' ? '#ebfaff' : theme.palette.background.paper,
        borderStyle: 'solid',
        borderColor: '#5a92af',
        borderWidth: 1,
        boxShadow: 'none'
    },
    cardHeader: {
        backgroundColor: '#5a92af',
        color: 'white',
        paddingTop: 0,
        paddingBottom: 0,
    },
    danger: {
        color: red[600],
    },
    buttonProgress: {
        color: '#2E94B9',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    buttonWrapper: {
        position: 'relative',
    },
    //#endregion

    //#region DeliveryOrders Dialog
    purchaseOrdersTable: {
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .purchase-orders-table--header': {
            backgroundColor: '#86C1D4',
            color: 'white',
            fontWeight: 'bold',
            textTransform: 'uppercase'
        },
        '& svg.MuiSvgIcon-root.MuiDataGrid-iconSeparator': {
            display: 'none'
        }

    },
    table: {
        backgroundColor: theme.palette.background.paper,
    },
    //#endregion
}));
function PurchaseOrdersDialog(props) {
    const classes = useStyles();
    const { onClose, open, setPoItems, handleSetPoItems } = props;
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [searchFormData, setSearchFormData] = useState({ poNo: "", material: "", vendor: "" })
    const [selectedPo, setSelectedPo] = React.useState([]);
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [tableParameters, setTableParameters] = useState({
        rowCount: 0, sortModel: [], dataGridParameters: { "page": 0, "pageSize": 20 }
    })
    const [fetchItem, setFetchItem] = useState([]);

    async function fetchTableData(formData) {
        setIsTableLoading(true);
        PurchaseOrdersService.searchPurchaseOrders(formData).then(
            (response) => {
                if (response.data) {
                    setFetchItem(response.data);
                    setIsTableLoading(false);
                }
            });
    };
    useEffect(() => {
        fetchTableData({ ...tableParameters, ...searchFormData })
    }, []);

    const columns = useMemo(() =>
        [
            {
                field: 'poNo', headerName: 'Po No', width: 120, headerClassName: 'purchase-orders-table--header'
            },
            { field: 'customerName', headerName: 'Customer Name', width: 230, headerClassName: 'purchase-orders-table--header' },
            { field: 'poItemNo', headerName: 'Po Iten No', width: 110, headerClassName: 'purchase-orders-table--header' },
            { field: 'materialNo', headerName: 'Material No', width: 130, headerClassName: 'purchase-orders-table--header' },
            { field: 'materialShort', headerName: 'Material Name', flex: 1, headerClassName: 'purchase-orders-table--header' },
            { field: 'quantity', headerName: 'Quantity', width: 130, align: 'right', headerClassName: 'purchase-orders-table--header' },
        ], [fetchItem]);

    const rows = useMemo(() => fetchItem.result, [fetchItem]);

    const handlePageSizeTransactionsTable = (event) => {
        fetchTableData({ ...searchFormData, ...tableParameters, 'dataGridParameters': { ...tableParameters.dataGridParameters, pageSize: event } });
    };
    const handlePageChangeTransactionsTable = (event) => {
        setTableParameters({ ...tableParameters, 'dataGridParameters': { page: event, pageSize: 20 } })
        fetchTableData({ ...searchFormData, ...tableParameters, 'dataGridParameters': { page: event, pageSize: 20 } });
    };
    const handleSortTransactionsTable = (event) => {
        if (!_.isEqual(event[0], tableParameters.dataGridSort)) {
            if (event[0]) {
                setTableParameters({ ...tableParameters, 'dataGridParameters': { "page": 0, "pageSize": 20 }, 'dataGridSort': event[0] })
                fetchTableData({ ...searchFormData, ...tableParameters, 'dataGridParameters': { "page": 0, "pageSize": 20 }, 'dataGridSort': event[0] });
            }
            else {
                setTableParameters({ ...tableParameters, 'dataGridParameters': { "page": 0, "pageSize": 20 }, 'dataGridSort': { field: '', sort: '' } })
                fetchTableData({ ...searchFormData, ...tableParameters, 'dataGridParameters': { "page": 0, "pageSize": 20 }, 'dataGridSort': { field: '', sort: '' } });
            }
        }
    };
    const handleClose = () => {
        onClose();
    };
    const handleChangeSelection = (selection) => {
        const newSelectionModel = selection;
        let poNo;
        if (newSelectionModel.length > 1) {
            const selectionSet = new Set(selectionModel);
            const result = newSelectionModel.filter(
                (s) => !selectionSet.has(s)
            );
            poNo = result[0];
            setSelectionModel(result);
        } else {
            setSelectionModel(newSelectionModel);
            poNo = newSelectionModel[0];
        }
        var splitPo = poNo.split("|-|");
        const poFilterItems = fetchItem.result.filter((po) => {
            return po.poNo === splitPo[0] && po.poItemNo === splitPo[1];
        })
        setPoItems(poFilterItems);
    };
    const handleSearchFormChange = (prop) => (event) => {
        setSearchFormData({ ...searchFormData, [prop]: event.target.value });
    };
    const handleSelectPoSubmit = () => {
        handleSetPoItems();
        handleClose();
    };
    const handleSearchSubmit = (search) => {
        fetchTableData({ ...tableParameters, ...searchFormData });
    };
    return (
        <Dialog
            fullWidth={true}
            maxWidth="md"
            onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        Purchase Orders
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="poNo"
                            name="poNo"
                            label="Purchase Order"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={searchFormData.poNo}
                            onChange={handleSearchFormChange('poNo')}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="vendor"
                            name="vendor"
                            label="Vendor"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={searchFormData.vendor}
                            onChange={handleSearchFormChange('vendor')}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="material"
                            name="material"
                            label="Material"
                            placeholder="Material No or Material Name"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={searchFormData.material}
                            onChange={handleSearchFormChange('material')}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Button onClick={handleSearchSubmit} variant="contained" color="primary">Search</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogTitle>
            <div style={{ height: 400, width: '100%' }} className={classes.purchaseOrdersTable}>
                <DataGrid
                    loading={isTableLoading}
                    components={{
                        LoadingOverlay: LoadingTableOverlay,
                    }}
                    rows={rows}
                    columns={columns}
                    page={fetchItem.page}
                    pageSize={tableParameters?.dataGridParameters?.pageSize ?? 20}
                    rowCount={fetchItem.rowCount}
                    disableColumnMenu={true}
                    disableColumnSelector={true}
                    density="compact"
                    paginationMode="server"
                    sortingMode="server"
                    checkboxSelection
                    disableClickEventBubbling={true}
                    getRowId={(row) => row.poNo + '|-|' + row.poItemNo}
                    selectionModel={selectionModel}
                    onSelectionModelChange={handleChangeSelection}
                    onPageSizeChange={handlePageSizeTransactionsTable}
                    onPageChange={handlePageChangeTransactionsTable}
                    onSortModelChange={handleSortTransactionsTable}
                />
            </div>
            <DialogActions>
                <Grid container>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="flex-start"
                        >
                            <Button onClick={handleClose} variant="contained" color="default">Cancel</Button>
                            <Box ml={1}>
                                <Button onClick={handleSelectPoSubmit} variant="contained" color="primary">Select</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

